module.exports = __webpack_public_path__ + "img/LapizInvertido.2993fb26.png";